import { actionGenerator } from "utils";
import { CREATE_TURN, SPIN, TOPUP, EXCHANGE_CODE } from "./constants";

const actions = {
  CREATE_TURN: actionGenerator.genActions(CREATE_TURN),
  SPIN: actionGenerator.genActions(SPIN),
  TOPUP: actionGenerator.genActions(TOPUP),
  EXCHANGE_CODE: actionGenerator.genActions(EXCHANGE_CODE),
};

export default actions;
